export default "__VITE_ASSET__72ef8f20__"